export const parseFooterExplore = (category, relatedPost) => {
  const getPostCategory = () => {
    if (category && category.nodes) {
      return category.nodes[0];
    }
    return {
      name: '',
      description: '',
    };
  };

  const getRelatedPosts = () => {
    return relatedPost.map((post) => {
      return {
        title: post.title,
        slug: `/${post.slug}`
      };
    });
  };

  let explore = {
    category: {
      name: getPostCategory().name,
      description: getPostCategory().description,
    },
    relatedPosts: getRelatedPosts(),
  };

  return explore;
};
